// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3RNpU","colMin":"styles_colMin__zqMzO","colCheckbox":"styles_colCheckbox__1FJew"};